module.exports = __webpack_public_path__ + "static/media/jello.9ec4b4d9.jpg";